import React, { useState } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { DiscountsTab } from "./DiscountsTab";
import { MyCoursesTab } from "./MyCoursesTab";
// import { MyPurchasesTab } from "./MyPurchasesTab";
import { PromotionsTab } from "./PromotionsTab";
import { UpcomingCoursesTab } from "./UpcomingCoursesTab";
// import PropTypes from "prop-types";
import styles from "./styles/InstructorCoursesPage.module.css";
import { useSelector } from "react-redux";
import { DraftCourse } from "./DraftCourse";

const InstructorCoursesPage = () => {
  const [toggleState, setToggleState] = useState(1);
  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getDetailsCourseForUpdate = useSelector(
    (state) => state.course.getDetailsCourseForUpdate
  );

  return (
    <Container className="p-5 position-relative">
      <h5>
        <i className="bi bi-book mr-2"></i>
        Courses
      </h5>

      <Row className="mt-5">
        <Col
          md={12}
          className={clsx("p-4 border rounded", styles.createCourseContainer)}
        >
          <h4 className="d-flex">
            <i className="bi bi-book mr-4 "></i>Jump Into Course Creation
          </h4>
          <Link to="/create-new-course">
            <Button>Create Your Course</Button>
          </Link>
        </Col>
      </Row>

      <Row className={clsx("mt-5 border rounded", styles.tabContainer)}>
        <Col
          sm={12}
          md={6}
          lg
          className={clsx(
            styles.tabItem,
            toggleState === 1 && styles.tabActive
          )}
          onClick={() => toggleTab(1)}
        >
          <i className="bi bi-book mr-2"></i>My Courses
        </Col>
        <Col
          sm={12}
          md={6}
          lg
          className={clsx(
            styles.tabItem,
            toggleState === 2 && styles.tabActive
          )}
          onClick={() => toggleTab(2)}
        >
          <i className="bi bi-archive  mr-2"></i>Draft Course
        </Col>
        {/* <Col
          sm={12}
          md={6}
          lg
          className={clsx(
            styles.tabItem,
            toggleState === 3 && styles.tabActive
          )}
          onClick={() => toggleTab(3)}
        >
          <i className="bi bi-upload mr-2"></i>Upcoming Courses
        </Col> */}
        <Col
          sm={12}
          md={6}
          lg
          className={clsx(
            styles.tabItem,
            toggleState === 4 && styles.tabActive
          )}
          onClick={() => toggleTab(4)}
        >
          <i className="bi bi-tag mr-2"></i>Discounts
        </Col>
        {/* <Col
          sm={12}
          md={6}
          lg
          className={clsx(
            styles.tabItem,
            toggleState === 5 && styles.tabActive
          )}
          onClick={() => toggleTab(5)}
        >
          <i className="bi bi-megaphone mr-2"></i>Promotions
        </Col> */}
      </Row>

      <Row className="mt-4">
        <Col md={12} className="m-0 p-0">
          {toggleState === 1 && <MyCoursesTab />}
          {/* {toggleState === 2 && <MyPurchasesTab />} */}
          {toggleState === 2 && <DraftCourse />}
          {toggleState === 3 && <UpcomingCoursesTab />}
          {toggleState === 4 && <DiscountsTab />}
          {toggleState === 5 && <PromotionsTab />}
        </Col>
      </Row>
      {getDetailsCourseForUpdate.processing ? (
        <div className={styles.spinnerMask}>
          <div className="text-center">
            <Spinner animation="border" variant="danger" />
            <div className="text-danger">Loading...</div>
          </div>
        </div>
      ) : null}
    </Container>
  );
};

/* required: display name */
InstructorCoursesPage.displayName = "InstructorCoursesPage";

/* required: props types */
InstructorCoursesPage.propTypes = {};

/* required: default props */
InstructorCoursesPage.defaultProps = {};

export { InstructorCoursesPage };
